<template>
    <div style="width:1200px">
        <div class="topicon">
            <slot name="icon"></slot>
        </div>
        <div class="contenttitle">
            <slot name="title"></slot>
        </div>
        <div class="bottomtext">
            <slot name="text"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'four',

    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>

<style lang="less" scoped>
.topicon img {
    display: block;
    margin: auto;
}

.contenttitle p {
    text-align: center;
    font-size: 24px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #353535;
    line-height: 28px;
    margin: 20px 0;
}

.bottomtext p {
    text-indent: 2em;
    text-align: left;
    margin: auto;
    width: 1142px;
    height: 112px;
    font-size: 16px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #565656;
    line-height: 32px;
    margin-top: 30px;
}
</style>